import { TimePicker, Checkbox, DatePicker } from "@ds/ds-snam/react";
import { IBayes, ICalendarDialogForm, IUnvailableBayes} from "dataModels/b2b";
import { getBayes } from "net/b2b";
import React, { MutableRefObject, forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useDispatch, useSelector } from "react-redux";
import { DATE_FORMAT, DsLayout } from "shared/constants";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { RootState } from "state/appStore";

interface NotAvaiableSlotsFormProps {
}
const defaultFormData: IUnvailableBayes = {
    startDate:moment.utc(new Date(), DATE_FORMAT).unix(),
    endDate:moment.utc(new Date(), DATE_FORMAT).unix(),
    startTime:'00:00',
    endTime:'00:00',
    bayes:[]
}
const NotAvailableSlotsForm= forwardRef<ICalendarDialogForm, NotAvaiableSlotsFormProps>((props, ref) => {
    const dispatch = useDispatch();
    const localRef  = useRef<HTMLDivElement>(null);
    const [formData,setFormData]=useState<IUnvailableBayes>(defaultFormData);
    const [bayes,setBayes]=useState<IBayes[]|undefined>();
    const { t, i18n } = useTranslation(["b2b", "app"]);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    useImperativeHandle(ref, () => ({
        getFormValues: () => {
          return formData //qua ritornare il formdata
        }
    }));

    const loadData = useCallback(() => {
        dispatch(requestPending());
        getBayes()
            .then((response: any) => {
                //mi serve solamente per creare le checkbox, ma di base sono tutte sflaggate, mi serve solo per fare la map
                setBayes(response);
                let currentFormData = formData;
                currentFormData.startDate=moment.utc(new Date(), DATE_FORMAT).unix();
                currentFormData.endDate=moment.utc(new Date(), DATE_FORMAT).unix();
                currentFormData.startTime='00:00';
                currentFormData.endTime='00:00';
                currentFormData.bayes=response;
                setFormData(currentFormData);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }, [dispatch]);

    useEffect(() => {
        loadData();
    }, []);

    const checkboxChangeHandler = (bayId:string,event:Event) => {
        //console.log(bayId + " - " +(event as CustomEvent).detail.checkbox.checked);
        let currentFormData = formData;
        for(let index in currentFormData.bayes){
            if(currentFormData.bayes[index].id===bayId){
                currentFormData.bayes[index].unavailable=(event as CustomEvent).detail.checkbox.checked;
            }
        }
        setFormData(currentFormData);
    }

    const onDateInputChange = (inputEvent: Event,label:string) => {
        let currentFormData = formData;
        const date: string = (inputEvent as CustomEvent).detail.dateSelection;
        //console.log(date)
        //let timestamp = moment(date, DATE_FORMAT).unix()
        (currentFormData[label as keyof IUnvailableBayes] as number) = moment.utc(date, DATE_FORMAT).unix();
        setFormData(currentFormData);
    }

    const onTimeInputChange = (inputEvent: Event,label:string) => {
        let currentFormData = formData;
        (currentFormData[label as keyof IUnvailableBayes] as string) = (inputEvent as CustomEvent).detail.time;
        setFormData(currentFormData);
    }

    const getRow = (datePickerId:string,datePickerTitle:string,confirmButtonLabel:string,timePickerId:string,timePickerTitle:string) => {
        return (
            <Row style={{marginTop:'15px'}}>
                <Col xs={12} md={6}>
                    <DatePicker
                        id={datePickerId}
                        datePickerTitle={datePickerTitle} //Data di inizio*
                        isRangePicker={false}
                        datePickerVariant="full-date"
                        startingYear={1990}
                        endingYear={2099}
                        disabledDates={{ lastDisabledDate: new Date(Date.now() - 86400000) }} 
                        defaultDate={new Date()} 
                        isDisabled={false}
                        datePickerStatus="default"
                        confirmButtonLabel={confirmButtonLabel} //conferma
                        hasCloseButton={false}
                        isReadonly={false}
                        onDateSelection={(event: Event) => {
                            onDateInputChange(event, datePickerId)
                        }}
                    ></DatePicker> 
                </Col>
                <Col xs={12} md={6}>
                    <TimePicker
                        id={timePickerId}
                        timePickerTitle={timePickerTitle} //Orario di inizio*
                        startTime={"00:00"}
                        endTime={"23:59"}
                        timeInterval={5}
                        timePickerStatus="default"
                        defaultTime={"00:00"}
                        zIndex={1999}
                        //isPanelTop={false}
                        onTimeSelection={(event: Event)=>{
                            onTimeInputChange(event,timePickerId)
                        }}
                    />
                </Col>
            </Row>
        );
    }


    
    return (
        <>  
            <div ref={localRef} style={{color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                <div slot="title">
                    <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",width:'fit-content',textAlign:'center',marginLeft:'65px',marginRight:'65px' }} id="overlay-title">
                    {t('calendar.popups.notAvailable.0')} {/*Confermi di voler salvare l'indisponibilità?*/}
                    </h2>
                    <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px' }}>{t('calendar.popups.notAvailable.1')} {/*Seleziona dettagli slot*/}</p>
                </div>
                <div slot="text" style={{ background:'',margin:'15px',paddingLeft:'5%',paddingRight:'5%',marginTop:'20px'}}>
                    {getRow(
                        "startDate",
                        t('calendar.popups.notAvailable.2'),
                        t('calendar.popups.buttons.8'),
                        'startTime',
                        t('calendar.popups.notAvailable.4')
                    )}
                    {getRow(
                        "endDate",
                        t('calendar.popups.notAvailable.3'),
                        t('calendar.popups.buttons.8'),
                        'endTime',
                        t('calendar.popups.notAvailable.5')
                    )}
                    <Row>
                        <div style={{border:'1px solid grey',width:'100%',marginLeft:'25px',marginRight:'25px',marginTop:'15px'}}></div>
                    </Row>

                    <Row>
                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px' }}>{t('calendar.popups.notAvailable.6')}</p> {/* Seleziona baie indisponibili */}
                    </Row>
                    <Row style={{marginTop:'15px'}}>
                        {bayes!==undefined &&
                            <>
                            {bayes.map((bay: IBayes, index: number) => {
                                const key: string = uuidv4();
                                return (
                                    <Col xs={12} md={3} key={key}>
                                        <Checkbox
                                            id={bay.id}
                                            checkboxStatus="default"
                                            checkboxLabel={t('calendar.popups.notAvailable.8')+bay.bayName} //Baia 
                                            isDisabled={false}
                                            isChecked={false}
                                            onCheckboxChange={(event:Event) => {
                                                checkboxChangeHandler(bay.id,event);
                                            }}
                                        />
                                    </Col>
                                )
                            })}
                            </>
                        }
                    </Row>
                    <Row>
                        <p style={{ marginTop:'20px',fontSize:'70%',marginLeft:'25px',}}>{t('calendar.popups.notAvailable.7')}</p> {/* Selezionando tutte le baie, lo slot apparirà a calendario come non disponibile*/}
                    </Row>
                </div>
            </div>
        </>
    );
});
export default NotAvailableSlotsForm;